import { defineMessages } from 'react-intl';

import {
    SCENARIOS,
    REWARD_TYPES,
    ANNUAL_FEE_OPTIONS,
    REWARD_SORT_OPTIONS,
    LOW_INTEREST_SORT_OPTIONS,
} from '@ratehub/cc-common';


export default defineMessages({
    sponsored: {
        id: 'web-components.ProductTable.sponsored',
        defaultMessage: 'Sponsored',
    },
    featured: {
        id: 'web-components.ProductTable.featured',
        defaultMessage: 'Featured',
    },

    // Mortgages
    termByYear: {
        id: 'web-components.ProductTableMortgages.termByYear',
        defaultMessage: '{value, select, 1 {1 year} other {{value} years}}',
    },
    tableRate: {
        id: 'web-components.ProductTableMortgages.tableRate',
        defaultMessage: 'Rate',
    },
    tableTerm: {
        id: 'web-components.ProductTableMortgages.tableTerm',
        defaultMessage: 'Term',
    },
    tableType: {
        id: 'web-components.ProductTableMortgages.tableType',
        defaultMessage: 'Type',
    },
    tableProvider: {
        id: 'web-components.ProductTableMortgages.tableProvider',
        defaultMessage: 'Provider',
    },
    tablePayment: {
        id: 'web-components.ProductTableMortgages.tablePayment',
        defaultMessage: 'Payment',
    },
    tableCashback: {
        id: 'web-components.ProductTableMortgages.tableCashback',
        defaultMessage: 'Cashback',
    },
    bonusUpTo: {
        id: 'web-components.ProductTableMortgages.bonusUpTo',
        defaultMessage: 'Up to',
    },
    pillSwitch: {
        id: 'web-components.ProductTableMortgages.pillSwitch',
        defaultMessage: 'Switch',
    },
    switchBonusTooltipTitle: {
        id: 'web-components.ProductTableMortgages.switchBonusTooltipTitle',
        defaultMessage: 'Switch bonus',
    },

    // Credit cards
    card: {
        id: 'web-components.ProductTableCreditCardScenarios.tableCard',
        defaultMessage: 'Card',
    },
    annualFee: {
        id: 'web-components.ProductTableCreditCardScenarios.annualFee',
        defaultMessage: 'Annual fee',
    },
    bestUsedFor: {
        id: 'web-components.ProductTableCreditCardScenarios.bestUsedFor',
        defaultMessage: 'Best used for',
    },
    purchaseInterestRate: {
        id: 'web-components.ProductTableCCLowInterest.purchaseInterestRate',
        defaultMessage: 'Purchase interest rate',
    },
    balanceTransferOffer: {
        id: 'web-components.ProductTableCCBalanceTransfer.balanceTransferOffer',
        defaultMessage: 'Balance transfer offer',
    },
    balanceTransferRate: {
        id: 'web-components.ProductTableCCBalanceTransfer.balanceTransferRate',
        defaultMessage: 'Balance transfer rate',
    },
    termUntil: {
        id: 'web-components.ProductTableCCBalanceTransfer.rateUntil',
        defaultMessage: 'First {term} months',
    },
    termAfter: {
        id: 'web-components.ProductTableCCBalanceTransfer.rateAfter',
        defaultMessage: 'After {term} months',
    },
    rewards: {
        id: 'web-components.ProductTableCCRewards.rewards',
        defaultMessage: 'Rewards',
    },
    cashBack: {
        id: 'web-components.ProductTableCCRewards.cashBack',
        defaultMessage: 'Cash back',
    },

    [REWARD_TYPES.ALL]: {
        id: 'web-components.creditCardRateTable.allRewardsTypes',
        defaultMessage: 'All reward types',
    },
    [REWARD_TYPES.CASH_BACK]: {
        id: 'web-components.creditCardRateTable.cashBackLabel',
        defaultMessage: 'Cash back',
    },
    [REWARD_TYPES.TRAVEL]: {
        id: 'web-components.creditCardRateTable.travelLabel',
        defaultMessage: 'Travel',
    },
    [REWARD_TYPES.STORE_CREDIT]: {
        id: 'web-components.creditCardRateTable.storeCreditLabel',
        defaultMessage: 'Store credit',
    },
    [SCENARIOS.REWARDS]: {
        id: 'web-components.creditCardRateTable.rewardsLabel',
        defaultMessage: 'Rewards',
    },
    [SCENARIOS.LOW_INTEREST]: {
        id: 'web-components.creditCardRateTable.lowInterestLabel',
        defaultMessage: 'Low interest',
    },
    [SCENARIOS.BALANCE_TRANSFER]: {
        id: 'web-components.creditCardRateTable.balanceTransferLabel',
        defaultMessage: 'Balance transfer',
    },
    [SCENARIOS.SECURED]: {
        id: 'web-components.creditCardRateTable.securedLabel',
        defaultMessage: 'Secured',
    },

    [ANNUAL_FEE_OPTIONS.NO_FEE]: {
        id: 'web-components.creditCardRateTable.cardNoFee',
        defaultMessage: 'No annual fee',
    },
    [ANNUAL_FEE_OPTIONS.ANY_FEE]: {
        id: 'web-components.creditCardRateTable.cardAnyFee',
        defaultMessage: 'Any annual fee',
    },

    [REWARD_SORT_OPTIONS.RECOMMENDED]: {
        id: 'web-components.cc-product-list.sort.recommended',
        defaultMessage: 'Ratehub recommended',
    },
    [REWARD_SORT_OPTIONS.FIRST_YEAR_VALUE]: {
        id: 'web-components.cc-product-list.sort.firstYearValue',
        defaultMessage: 'First year reward value',
    },
    [REWARD_SORT_OPTIONS.SUBSEQUENT_YEAR_VALUE]: {
        id: 'web-components.cc-product-list.sort.subsequentYearValue',
        defaultMessage: 'Subsequent year reward value',
    },
    [REWARD_SORT_OPTIONS.WELCOME_BONUS]: {
        id: 'web-components.cc-product-list.sort.welcomeBonus',
        defaultMessage: 'Welcome bonus',
    },
    [REWARD_SORT_OPTIONS.ANNUAL_FEE]: {
        id: 'web-components.cc-product-list.sort.annualFee',
        defaultMessage: 'Annual fee (low to high)',
    },
    [LOW_INTEREST_SORT_OPTIONS.PURCHASE_INTEREST_RATE]: {
        id: 'web-components.cc-product-list.sort.purchase-interest',
        defaultMessage: 'Purchase interest rate',
    },
});
